import * as React from 'react';

export interface IUser {
  userId?: string;
  favourites?: string[];
}

export const defaultUser: IUser = {
  favourites: null,
  userId: null,
};

export const UserContext: React.Context<IUser> = React.createContext(defaultUser);

UserContext.displayName = 'UserContext';
